import type { AutoformatRule } from '../../types';

export const autoformatFraction: AutoformatRule[] = [
  {
    format: '½',
    match: '1/2',
    mode: 'text',
  },
  {
    format: '⅓',
    match: '1/3',
    mode: 'text',
  },
  {
    format: '¼',
    match: '1/4',
    mode: 'text',
  },
  {
    format: '⅕',
    match: '1/5',
    mode: 'text',
  },
  {
    format: '⅙',
    match: '1/6',
    mode: 'text',
  },
  {
    format: '⅐',
    match: '1/7',
    mode: 'text',
  },
  {
    format: '⅛',
    match: '1/8',
    mode: 'text',
  },
  {
    format: '⅑',
    match: '1/9',
    mode: 'text',
  },
  {
    format: '⅒',
    match: '1/10',
    mode: 'text',
  },
  {
    format: '⅔',
    match: '2/3',
    mode: 'text',
  },
  {
    format: '⅖',
    match: '2/5',
    mode: 'text',
  },
  {
    format: '¾',
    match: '3/4',
    mode: 'text',
  },
  {
    format: '⅗',
    match: '3/5',
    mode: 'text',
  },
  {
    format: '⅜',
    match: '3/8',
    mode: 'text',
  },
  {
    format: '⅘',
    match: '4/5',
    mode: 'text',
  },
  {
    format: '⅚',
    match: '5/6',
    mode: 'text',
  },
  {
    format: '⅝',
    match: '5/8',
    mode: 'text',
  },
  {
    format: '⅞',
    match: '7/8',
    mode: 'text',
  },
];
